import {
    ProtocolLogger,
    ProtocolStep,
} from "https://static.ladies-cdn.de/ladies/js-packages/protocol-logger/0.2-latest/index.js"
import { LadiesMain } from "../global/ladies-main"
import { InfoPanel } from "../info-panel/InfoPanel.js"
import { Cookie } from "../util/Cookie"
import StarsNotifications from "./StarsNotifications.js"
import { SubscribeApiModalHandler } from "./subscribe-api-modal-handler.js"
import { SubscribeApi } from "./subscribe-api.js"
import { SubscriptionStatusApi } from "./subscription-status-api.js"

export default class StarsSubscription {
    /**
     * @property {string} StarsSubscription.protocolLogger
     * @property {string} StarsSubscription.apiBaseUrl
     * @property {boolean} StarsSubscription.isYourStarsPage
     * @property {HTMLElement} StarsSubscription.ownerName
     * @property {array} LadiesStars.ownerId
     *
     * @property {HTMLElement} StarsSubscription.subscriptionModal
     * @property {HTMLCollection} StarsSubscription.inModalSubscriptionButtons
     * @property {FormData} StarsSubscription.subscriptionFormData
     */
    constructor() {
        this.starsNotifications = new StarsNotifications()
        // "ladies_" is an agreed on index necessary for the protocol logger import. Otherwise, it would be ignored (and samuel will be angry at us ;( ).
        this.protocolLogger = new ProtocolLogger("ladies_subscription-request")
        this.apiBaseUrl = SiteInfo.yiiLadiesApiUrl
        this.isYourStarsPage = false
        const dataIsYourStarsPage = document.getElementById("dataIsYourStarsPage")
        if (dataIsYourStarsPage && dataIsYourStarsPage.value === "1") {
            this.isYourStarsPage = true
        }
        this.subscriptionModal = document.getElementById("subscriptionModal")
        this.subscriptionModalBuyButtons = document.getElementById("subscriptionModalBuyButtons")
        this.inModalSubscriptionButtons = document.getElementsByClassName("btn-request-subscription")
        this.cancelSubscriptionButtons = document.getElementsByClassName("btnCancelSubscription")
        this.buyCoinsButtons = document.getElementsByClassName("buyCoinsButton")
        this.loadingOverlay = document.getElementById("loading-overlay")
        this.subscriptionModalTemporary = document.getElementById("subscriptionModalTemporary")
        this.proceedInactiveStarBuyButton = document.getElementById("proceeed-to-buy-inactive-star")
        this.subscriptionModalWarning = document.getElementById("subscriptionModalWarning")
        this.subscriptionModalHeading = document.getElementById("subscriptionHeading")
        this.disabled48hAboList = []
        if (document.getElementById("data-disabled-48h-star-ids") !== null) {
            this.disabled48hAboList = Array.from(
                JSON.parse(document.getElementById("data-disabled-48h-star-ids").value),
            )
        }

        this.subscriptionFormData = new FormData()

        this.subscriptionNoticeCookie = new Cookie("subscriptionNotice", {
            path: "/",
            domain: SiteInfo.cookieDomain,
        })

        this.starProfileCalledFromMyStarsCookie = new Cookie("starProfileCalledFromMyStars", {
            path: "/",
            domain: SiteInfo.cookieDomain,
        })

        this.displaySubscriptionMessage()
        this.addStarsContentEventListeners()
    }

    addStarsContentEventListeners() {
        // Bootstrap modal events only work with jQuery

        if (this.proceedInactiveStarBuyButton) {
            this.proceedInactiveStarBuyButton.addEventListener("click", this.proceedInactiveStarBuy.bind(this))
        }

        if (this.subscriptionModal) {
            $(this.subscriptionModal).on("show.bs.modal", (/** jQuery.Event */ modalEvent) => {
                this.updateSubscriptionModalWithCreatorData(modalEvent.relatedTarget.value)
                return this.showSubscriptionModalContent(modalEvent)
            })

            $(this.subscriptionModal).on("hide.bs.modal", (/** jQuery.Event */ modalEvent) =>
                this.hideSubscriptionModalContent(modalEvent),
            )

            $(this.subscriptionModal).on("show.bs.modal hide.bs.modal", (/** jQuery.Event */ modalEvent) =>
                this.setUnsetOpenStarsModalClass(modalEvent),
            )
        }

        $(this.subscriptionModalTemporary).on("hide.bs.modal", (/** jQuery.Event */ modalEvent) =>
            this.hideSubscriptionModalTemporaryContent(modalEvent),
        )

        if (this.subscriptionModalBuyButtons) {
            $(this.subscriptionModalBuyButtons).on("show.bs.modal", (/** jQuery.Event */ modalEvent) =>
                this.toggleSubscriptionModalBuyButtonsContent(modalEvent),
            )

            $(this.subscriptionModalBuyButtons).on("hide.bs.modal", (/** jQuery.Event */ modalEvent) =>
                this.hideSubscriptionModalBuyButtonsContent(modalEvent),
            )

            $(this.subscriptionModalBuyButtons).on("show.bs.modal hide.bs.modal", (/** jQuery.Event */ modalEvent) =>
                this.setUnsetOpenSubscriptionModalBuyButtonsClass(modalEvent),
            )
        }

        if (this.cancelSubscriptionButtons) {
            for (const btn of this.cancelSubscriptionButtons) {
                if (btn instanceof HTMLElement) {
                    btn.addEventListener("click", this.reloadPageAfterSubscriptionSucceed.bind(this))
                }
            }
        }

        if (this.buyCoinsButtons) {
            for (const btn of this.buyCoinsButtons) {
                if (btn instanceof HTMLElement) {
                    btn.addEventListener("click", this.changeBuyCoinButton.bind(this, btn))
                }
            }
        }

        if (this.inModalSubscriptionButtons) {
            for (const btn of this.inModalSubscriptionButtons) {
                if (btn instanceof HTMLElement) {
                    btn.addEventListener("click", this.requestSubscriptionAndPollForCreatedEvent.bind(this))
                }
            }
        }
    }

    hideSubscriptionModalContent() {
        LadiesMain.removeHashtagFromUrl("success-modal")
        LadiesMain.removeHashtagFromUrl("owner-id")
    }

    /**
     * @private
     */
    async showSubscriptionModalContent(/** jQuery.Event */ modalEvent) {
        const openSubscriptionStep = new ProtocolStep(
            "open subscription modal",
            new Date().toISOString(),
            "User started subscription flow by clicking on the subscription modal button.",
        )

        const ownerId = this.getOwnerIdFromElementValue(modalEvent.relatedTarget)

        openSubscriptionStep.addContext("starId", ownerId)

        this.protocolLogger.addStep(openSubscriptionStep)

        try {
            if (this.subscriptionModal.closest("main") instanceof HTMLElement) {
                document.body.append(this.subscriptionModal)
            }

            for (const section of this.subscriptionModal.querySelectorAll("section.ladiesplus.modal-inner")) {
                section.classList.add("hide")
            }

            const modalContentIdSelector = modalEvent.relatedTarget.dataset.content
            this.subscriptionModal.querySelector(modalContentIdSelector).classList.remove("hide")

            let ownerId = null
            if (this.isYourStarsPage) {
                ownerId = modalEvent.relatedTarget.value

                for (const button of this.subscriptionModal.querySelectorAll("button")) {
                    button.value = ownerId
                }
            }

            if (modalEvent.relatedTarget?.dataset.content) {
                const successModal = modalEvent.relatedTarget.dataset.content.slice(1)
                LadiesMain.addHashtagToUrl("success-modal", successModal)
                if (ownerId) {
                    LadiesMain.addHashtagToUrl("owner-id", ownerId)
                }
            }

            this.renderStarInactiveInformation(modalEvent, modalContentIdSelector, ownerId)
        } catch (error) {
            await this.logProtocolError(openSubscriptionStep, error)
        }
    }

    renderStarInactiveInformation(
        /** Event **/ modalEvent,
        /** string **/ modalContentIdSelector,
        /** string **/ ownerId,
    ) {
        const inactiveSinceDays = modalEvent.relatedTarget.dataset.starInactiveDays

        if (inactiveSinceDays) {
            document.getElementById("subscriptionModalWarningContentLowPostingFrequency").classList.add("hide")
            document.getElementById("subscriptionModalWarningContentNoPosts").classList.add("hide")

            let heading = "Star ist inaktiv"

            if (inactiveSinceDays === "-1") {
                heading = "Star hat aktuell keinen Beitrag"
                document.getElementById("subscriptionModalWarningContentNoPosts").classList.remove("hide")
            } else {
                document.getElementById("inactiveSinceDays").innerText = `${inactiveSinceDays} Tage`
                document.getElementById("subscriptionModalWarningContentLowPostingFrequency").classList.remove("hide")
            }

            this.subscriptionModalHeading.classList.add("hide")

            document
                .getElementById("subscriptionModalWarningHeading")
                .querySelector(".stars-modal-heading-warning").innerText = heading
            document.getElementById("subscriptionModalWarningHeading").classList.remove("hide")

            if (modalContentIdSelector) {
                this.proceedInactiveStarBuyButton.dataset.modalContentIdSelector = modalContentIdSelector
                this.subscriptionModal.querySelector(modalContentIdSelector).classList.add("hide")
            }

            this.subscriptionModalWarning.classList.remove("hide")

            this.updateSubscriptionModalWithCreatorData(ownerId)
        } else {
            this.subscriptionModalHeading.classList.remove("hide")
            document.getElementById("subscriptionModalWarningHeading").classList.add("hide")
            this.subscriptionModal.querySelector(modalContentIdSelector).classList.remove("hide")
            this.subscriptionModalWarning.classList.add("hide")
        }
    }

    toggleSubscriptionModalBuyButtonsContent(/** jQuery.Event */ modalEvent) {
        const ownerId = modalEvent.relatedTarget.value

        LadiesMain.addHashtagToUrl("subscription-modal-buy-buttons")

        const hasNo48hButton = this.disabled48hAboList.indexOf(ownerId) > -1

        const inactiveSinceDate = modalEvent.relatedTarget.dataset.starInactiveDays || ""

        this.subscriptionModalBuyButtons.querySelectorAll("button").forEach(
            function (button) {
                if (this.isYourStarsPage) {
                    button.dataset.starInactiveDays = inactiveSinceDate
                }

                if (button.dataset.content === "#subscriptionModal_48hours" && hasNo48hButton) {
                    button.classList.add("hidden")
                } else {
                    button.classList.remove("hidden")
                    button.value = ownerId
                }
            }.bind(this),
        )

        this.subscriptionModalBuyButtons.querySelectorAll(".subscriptionLink").forEach(
            function (link) {
                if (this.isYourStarsPage) {
                    link.dataset.starInactiveDays = inactiveSinceDate
                }

                if (link.dataset.content === "#subscriptionModal_48hours" && hasNo48hButton) {
                    link.classList.add("hidden")
                } else {
                    link.classList.remove("hidden")
                    link.value = ownerId
                }
            }.bind(this),
        )

        if (modalEvent.relatedTarget.dataset.modalTitle) {
            for (const subscriptionModal of document.getElementsByClassName("stars-subscription-modal")) {
                if (subscriptionModal instanceof HTMLElement) {
                    subscriptionModal.getElementsByClassName("stars-modal-heading")[0].innerHTML =
                        modalEvent.relatedTarget.dataset.modalTitle
                }
            }
        }

        this.updateSubscriptionModalWithCreatorData(ownerId)
    }

    updateSubscriptionModalWithCreatorData(ownerId) {
        const creatorContainer = document.getElementById(`stars-subscription-${ownerId}`)
        if (!creatorContainer) {
            return
        }

        const creatorName = creatorContainer.getElementsByClassName("creatorProfileName")[0].innerHTML
        const creatorAvatarSrc = creatorContainer.getElementsByClassName("creatorProfileAvatar")[0].getAttribute("src")
        for (const subscriptionModal of document.getElementsByClassName("stars-subscription-modal")) {
            if (subscriptionModal instanceof HTMLElement) {
                subscriptionModal
                    .getElementsByClassName("creatorProfileAvatar")[0]
                    .setAttribute("src", creatorAvatarSrc)
                for (const el of subscriptionModal.querySelectorAll(".creatorProfileName")) {
                    el.innerHTML = creatorName
                }
            }
        }
    }

    setUnsetOpenStarsModalClass(/** jQuery.Event */ modalEvent) {
        const starsModalClass = "stars-modal-open"

        if (modalEvent.type === "show") {
            document.body.classList.add(starsModalClass)
        } else {
            document.body.classList.remove(starsModalClass)
        }
    }

    async requestSubscriptionAndPollForCreatedEvent(event) {
        const requestProtocolStep = new ProtocolStep(
            "request subscription",
            new Date().toISOString(),
            "request subscription creation",
        )

        this.protocolLogger.addStep(requestProtocolStep)

        try {
            const packageName = event.currentTarget.dataset.package
            const ownerId = this.getOwnerIdFromElementValue(event.srcElement)
            let result

            if (SiteInfo.isCCStarSubscriptionApiActive) {
                const subscribeApiModalHandler = new SubscribeApiModalHandler(
                    this.subscriptionModalTemporary,
                    this.loadingOverlay,
                )
                const subscribeApi = new SubscribeApi()
                const response = await subscribeApi.fetch(
                    userData.userId,
                    Number.parseInt(ownerId),
                    packageName,
                    userData.accessToken,
                )

                result = await response.json()
                const messageId = result.messageId

                switch (messageId) {
                    case "SubscriptionPending":
                        subscribeApiModalHandler.adjustModalForPendingKey()
                        return
                    case "SubscriptionAlreadyActiveAndCantBeRenewed":
                        subscribeApiModalHandler.adjustModalForAlreadyActiveAndCantBeRenewed()
                        return
                    case "TrialSubscriptionAlreadyActive":
                        subscribeApiModalHandler.adjustModalForTrialSubscriptionAlreadyActive()
                        return
                    default:
                        break
                }

                if (response.status !== 200) {
                    subscribeApiModalHandler.adjustModalForError()
                    return
                }
            } else {
                this.subscriptionFormData.set("creatorId", ownerId)
                this.subscriptionFormData.set("package", packageName)

                const response = await fetch(`${this.apiBaseUrl}/v1/FansSubscription/subscribe`, {
                    method: "POST",
                    body: this.subscriptionFormData,
                    credentials: "include",
                })

                result = await response.json()

                if (result.result === "subscription_pending") {
                    $(this.subscriptionModalTemporary)
                        .find(".subscriptionTextContainer")
                        .html(
                            "Das Freischalten befindet sich bereits in Bearbeitung. Wir bitten um einen Moment Geduld.",
                        )
                    $(this.subscriptionModalTemporary).find(".btnCancelSubscription").html("OK")
                    $(this.subscriptionModalTemporary).find(".buy-coins-button").hide()
                    $(this.subscriptionModalTemporary).modal("show")
                    $(this.loadingOverlay).modal("hide")
                    return
                }

                if (result.result === "subscription_already_active_and_cant_be_renewed") {
                    $(this.subscriptionModalTemporary)
                        .find(".subscriptionTextContainer")
                        .html(
                            "Du bist bereits Fan von diesem Star, eine Verlängerung deines Fan-Status ist zur Zeit nicht möglich.",
                        )
                    $(this.subscriptionModalTemporary)
                        .find(".btnCancelSubscription")
                        .html("Seite neu laden")
                        .on("click", () => {
                            window.location.reload()
                        })
                    $(this.subscriptionModalTemporary).find(".buy-coins-button").hide()
                    $(this.subscriptionModalTemporary).modal("show")
                    $(this.loadingOverlay).modal("hide")
                    return
                }

                if (result.result === "subscription_already_active") {
                    $(this.subscriptionModalTemporary)
                        .find(".subscriptionTextContainer")
                        .html("Du bist bereits Fan von diesem Star.")
                    $(this.subscriptionModalTemporary)
                        .find(".btnCancelSubscription")
                        .html("Seite neu laden")
                        .on("click", () => {
                            window.location.reload()
                        })
                    $(this.subscriptionModalTemporary).find(".buy-coins-button").hide()
                    $(this.subscriptionModalTemporary).modal("show")
                    $(this.loadingOverlay).modal("hide")
                    return
                }

                if (response.status !== 200) {
                    //basically not possible as we need to send correlationId first or maybe change text here
                    $(this.subscriptionModalTemporary)
                        .find(".subscriptionTextContainer")
                        .html(
                            "Dein Kaufvorgang konnte nicht bearbeitet werden. Falls dieses Problem längere Zeit bestehen bleibt, dann wende dich bitte an den technischen Support.",
                        )
                    $(this.subscriptionModalTemporary).find(".btnCancelSubscription").html("OK")
                    $(this.subscriptionModalTemporary).find(".buy-coins-button").hide()
                    $(this.subscriptionModalTemporary).modal("show")
                    $(this.loadingOverlay).modal("hide")
                    return
                }
            }

            await this.pollSubscriptionStatus(
                5,
                Number.parseInt(ownerId),
                result.correlationId,
                result.grantedUntil,
                result.isAlreadyActive,
            )
        } catch (error) {
            await this.logProtocolError(requestProtocolStep, error)
        }
    }

    getOwnerIdFromElementValue(eventTarget) {
        if (this.isYourStarsPage) {
            return eventTarget.value
        }
        const ownerId = document.getElementById("data-creator-ids").value
        return JSON.parse(ownerId)[0]
    }

    async pollSubscriptionStatus(
        /** number */ maxPollCount,
        /** number */ ownerId,
        /** string **/ correlationId,
        /** string */ grantedUntil,
        /** string */ isAlreadyActive,
    ) {
        const protocolStep = new ProtocolStep(
            "poll subscription state",
            new Date().toISOString(),
            "Check if subscription was created or is pending.",
        )

        this.protocolLogger.addStep(protocolStep)

        let pollCount = 0

        this.subscriptionFormData.set("correlationId", correlationId)
        this.subscriptionFormData.set("grantedUntil", grantedUntil)
        this.subscriptionFormData.set("isActive", isAlreadyActive)

        this.starProfileCalledFromMyStarsCookie.expires = Cookie.getExpireDate(3600 * 24)
        this.starProfileCalledFromMyStarsCookie.value = this.subscriptionFormData.get("creatorId")

        const intervalId = setInterval(async () => {
            try {
                const abortController = new AbortController()
                const timeoutId = setTimeout(() => abortController.abort(), 2500)

                let response

                try {
                    const isActive = isAlreadyActive === "true"
                    if (SiteInfo.isCCStarSubscriptionApiActive) {
                        const subscriptionStatusApi = new SubscriptionStatusApi()
                        response = await subscriptionStatusApi.fetch(
                            userData.userId,
                            ownerId,
                            correlationId,
                            grantedUntil,
                            isActive,
                        )
                    } else {
                        response = await fetch(`${this.apiBaseUrl}/v1/FansSubscription/checkSubscriptionStatus`, {
                            method: "POST",
                            body: this.subscriptionFormData,
                            credentials: "include",
                            signal: abortController.signal,
                        })
                    }

                    clearTimeout(timeoutId)
                } catch (error) {
                    clearInterval(intervalId)
                    $(this.subscriptionModalTemporary)
                        .find(".subscriptionTextContainer")
                        .html(
                            "Zeitüberschreitung beim Abrufen des Status der Bestellung. Wir bitten um einen Moment Geduld.",
                        )
                    $(this.subscriptionModalTemporary).find(".btnCancelSubscription").html("OK")
                    $(this.subscriptionModalTemporary).find(".buy-coins-button").hide()
                    $(this.subscriptionModalTemporary).modal("show")
                    $(this.loadingOverlay).modal("hide")

                    throw new Error("Poll request timeout exceeded.")
                }

                if (response.status === 200) {
                    clearInterval(intervalId)

                    $(this.loadingOverlay).modal("hide")

                    this.changeSubscriptionModalText("")

                    this.subscriptionNoticeCookie.expires = Cookie.getExpireDate(3600)

                    const link = document.querySelector(`[data-creator-id="${ownerId}"]`)
                    const creatorName = link?.dataset.creatorName ?? null

                    if (creatorName === null) {
                        throw new Error("Creator name not found for creator id: " + ownerId)
                    }

                    this.subscriptionNoticeCookie.value = creatorName
                    window.location.reload()
                    return
                }

                const result = await response.json()

                if (result.result === "subscription_error_not_enough_coins") {
                    clearInterval(intervalId)
                    $(this.subscriptionModalTemporary)
                        .find(".subscriptionTextContainer")
                        .html("Für diese Aktion ist dein aktuelles Coins-Guthaben nicht ausreichend.")
                    $(this.subscriptionModalTemporary).find(".btnCancelSubscription").html("Abbrechen")
                    $(this.subscriptionModalTemporary).find(".buy-coins-button").show()
                    $(this.subscriptionModalTemporary).modal("show")
                    $(this.loadingOverlay).modal("hide")

                    LadiesMain.addHashtagToUrl("subscription-modal-buy-buttons")

                    return
                }

                if (result.messageId === "SubscriptionError") {
                    clearInterval(intervalId)
                    $(this.subscriptionModalTemporary)
                        .find(".subscriptionTextContainer")
                        .html(
                            "Dein Kaufvorgang konnte nicht bearbeitet werden. Falls dieses Problem längere Zeit bestehen bleibt, dann wende dich bitte an den technischen Support.",
                        )
                    $(this.subscriptionModalTemporary).find(".btnCancelSubscription").html("OK")
                    $(this.subscriptionModalTemporary).find(".buy-coins-button").hide()
                    $(this.subscriptionModalTemporary).modal("show")
                    $(this.loadingOverlay).modal("hide")
                }

                pollCount++

                if (pollCount >= maxPollCount) {
                    clearInterval(intervalId)

                    $(this.subscriptionModalTemporary).find(".btnCancelSubscription").html("OK")
                    $(this.subscriptionModalTemporary).find(".btn-lila").hide()
                    $(this.subscriptionModalTemporary).modal("show")
                    $(this.loadingOverlay).modal("hide")

                    this.changeSubscriptionModalText(
                        "Das Freischalten befindet sich in Bearbeitung. Wir bitten um einen Moment Geduld.",
                    )

                    throw new Error("Poll count exceeded.")
                }
            } catch (error) {
                await this.logProtocolError(protocolStep, error)
            }
        }, 3000)
    }

    changeSubscriptionModalText(/** string */ modalText) {
        for (const element of document.querySelectorAll("#subscriptionModalTemporary .subscriptionTextContainer")) {
            if (element instanceof HTMLElement) {
                element.innerText = modalText
            }
        }

        for (const element of document.querySelectorAll("#subscriptionModalTemporary .btnCancelSubscription")) {
            if (element instanceof HTMLElement) {
                element.innerText = "OK"
            }
        }
    }

    displaySubscriptionMessage() {
        if (this.subscriptionNoticeCookie.value !== "") {
            const subscriptionMessage = `Du bist jetzt Fan von ${this.getCreatorName()}`

            window.setTimeout(() => {
                InfoPanel.displayMessage(subscriptionMessage, InfoPanel.Type.Star)
            }, 10)

            this.subscriptionNoticeCookie.removeCookie()
        }
    }

    getCreatorName() {
        if (this.subscriptionNoticeCookie.value !== "") {
            return this.subscriptionNoticeCookie.value
        }

        return "Star"
    }

    proceedInactiveStarBuy(event) {
        this.subscriptionModalHeading.classList.remove("hide")

        document.getElementById("subscriptionModalWarningHeading").classList.add("hide")

        this.subscriptionModal
            .querySelector(event.currentTarget.dataset.modalContentIdSelector)
            .classList.remove("hide")

        this.subscriptionModalWarning.classList.add("hide")
    }

    reloadPageAfterSubscriptionSucceed() {
        if (this.subscriptionNoticeCookie.value !== "") {
            window.top.location.reload()
        }
    }

    changeBuyCoinButton(btn) {
        btn.innerText = "Aktualisieren"
        btn.classList.add("btn-white-lila")
        btn.classList.remove("btn-lila")

        btn.addEventListener(
            "click",
            (() => {
                window.top.location.reload()
            }).bind(this),
        )
    }

    async logProtocolError(openSubscriptionStep, error) {
        // TODO: implement new logging
        return
    }

    hideSubscriptionModalBuyButtonsContent(modalEvent) {
        LadiesMain.removeHashtagFromUrl("subscription-modal-buy-buttons")
    }

    setUnsetOpenSubscriptionModalBuyButtonsClass(modalEvent) {
        const starsModalClass = "stars-modal-open"

        if (modalEvent.type === "show") {
            document.body.classList.add(starsModalClass)
        } else {
            document.body.classList.remove(starsModalClass)
        }
    }

    hideSubscriptionModalTemporaryContent(modalEvent) {
        LadiesMain.removeHashtagFromUrl("success-modal")
        LadiesMain.removeHashtagFromUrl("owner-id")
    }
}

const starsSubscription = new StarsSubscription()
